import * as React from "react";
import { forwardRef } from "react";
const SvgFreeText = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15 18V16H3V18H15ZM15 13V11H3V13H15ZM21 8V6H3V8H21Z", fill: "#676A7B" }));
const ForwardRef = forwardRef(SvgFreeText);
export default ForwardRef;
